import { useMemo } from 'react';
import { Autocomplete, TextField } from '@mui/material';

export interface ParentOption {
  _id: string;
  name: string;
  code: string;
}

interface Props {
  label: string;
  value: string;
  options: ParentOption[];
  onChange: (parentId: string, option?: ParentOption) => void;
  required?: boolean;
  helperText?: string;
  error?: boolean;
  errorText?: string;
}

export default function ParentMasterSelect({
  label, value, options, onChange, required, helperText, error, errorText,
}: Props) {
  const selected = useMemo(
    () => options.find((o) => o._id === value) || null,
    [options, value],
  );

  return (
    <Autocomplete
      size="small"
      options={options}
      value={selected}
      getOptionLabel={(o) => `${o.name} (${o.code})`}
      isOptionEqualToValue={(a, b) => a._id === b._id}
      onChange={(_, opt) => onChange(opt?._id || '', opt || undefined)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          error={error || !!errorText}
          helperText={errorText || helperText || 'Search and select parent record'}
        />
      )}
      noOptionsText="No parent records — add parent masters first"
    />
  );
}
